<template>
    <modal
    name="modal-home-category-service-step2-aging"
    height="auto"
    width="70%"
    class="customSurveyModal"
    :scrollable="true"
    @before-open="beforeOpen"
    @closed="closed">

        <div class="row7">
            <header class="modalHeader flex flexAlignS homeCategoryStepHead">
            <div class="title">
                <div class="flex">
                    <p class="step">2단계</p>
                    <p class="steptitle mobileReset">고령친화서비스 - {{targetData.targetName}}</p>
                </div>
                <p class="mobileBlock steptitleMobile">
                    고령친화서비스 -  {{targetData.targetName}}
                </p>
                <p class="infoTxt">
                생활을 선택해주세요.
                </p>
            </div>
            <button @click="closed"></button>
            </header>
        </div>

        <div class="homeCategorybody">
            <div class="serviceSelectBox">
                <button v-for="(life, index) in lifeList" :key="index" :class="{selected: selectedLifeList.indexOf(life.IDX) > -1}" @click="selectLifeCategory(life.IDX)">
                    <figure>
                        <img :src="require('../../assets/images/cmmnMain/CategoryStep/icon/'+life.IMAGE)" v-bind:alt="life.NAME">
                        <figcaption>{{life.NAME}}</figcaption>
                    </figure>
                </button>
            </div>
        </div>
        
        <div class="modalFooterBtn btnBox leftPosition">
            <p class="redBtnP" @click="closed">
                <img src="../../assets/images/cmmnMain/CategoryStep/Chevron_Right.png" alt="">
                이전 화면으로 가기
            </p>
        </div>

        <div class="searchResultCon popupCon">
            <div class="searchResultTitle">
                <p>검색결과 : 총
                    <span>
                        {{totalCnt}}
                    </span>
                    건
                </p>
            </div>
            <hr>
            <div class="searchResultBody">
                <router-link v-for="(service, index) in items" :key="index" :to="'/serviceDetail/'+service.CATEGORY_IDX+'/'+service.SERVICE_IDX">
                    <div class="searchResultItem">
                        <div class="imgBox">
                            <img :src="service.MAIN_FILE" alt="">
                        </div>
                        <div class="title">
                            <p>
                                {{service.CATEGORY_NAME}}
                            </p>
                        </div>
                        <div class="subContent">
                            <table>
                                <tbody>
                                    <tr>
                                        <th>생활 구분</th>
                                        <td>{{service.LIFE}}</td>
                                    </tr>
                                    <tr>
                                        <th>업체명</th>
                                        <td>{{service.COMPANY}}</td>
                                    </tr>
                                    <tr>
                                        <th>서비스명</th>
                                        <td>{{service.NAME}}</td>
                                    </tr>
                                    <tr>
                                        <th>사용제안대상</th>
                                        <td>
                                            <p>
                                                {{service.TARGET}}
                                            </p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </router-link>
            </div>
        </div>
        <div class="tableContainer">
            <div class="sampleTemplate">
                <paginate
                    v-model="currentPage"
                    :page-count="navCnt"
                    :page-range="3"
                    :margin-pages="2"
                    :click-handler="onClickPagenation"
                    :prev-text="'‹'"
                    :next-text="'›'"
                    :container-class="'pagination b-pagination newPagination'">
                </paginate>
            </div>
        </div>
    </modal>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    name: 'ModalHomeCategoryServiceStep2',
    props:[
        'targetData'
    ],
    data(){
        return{
            modalResult: false,
            lifeList : [],
            selectedLifeList : [],
            items : null,
            totalCnt: 0,
            currentPage: 1,
            sortBy: 'IDX',
            sortDesc: false,
            perPage: 6
        }
    },
    watch:{
        selectedLifeList(){
            this.currentPage = 1;
            this.getService();
        }
    },
    computed:{
        navCnt : function(){            
            if(this.totalCnt % this.perPage == 0) return this.totalCnt/this.perPage
			else return Math.floor(this.totalCnt/this.perPage) + 1;
        },
    },
    mounted(){
        this.show();

        this.requestGetLifeListByTargetIdx(this.targetData.targetIdx)
        .then((response) => {
            this.lifeList = response.data;
        })
        .catch(() => {
            this.$alert('알림', '2단계 카테고리 데이터를 가져올 수 없습니다.');
        });

    },
    methods:{
        ...mapActions('category', [
            'requestGetLifeListByTargetIdx'
        ]),
        ...mapActions('service', [
            'requestServiceBySubCategory'
        ]),
        show(){
            this.$modal.show('modal-home-category-service-step2-aging')
        },
        hide(){
            this.$modal.hide('modal-home-category-service-step2-aging')
        },
        beforeOpen(){
        },
        closed(){
            this.$emit('modal-closed', this.$options.name, {result: this.modalResult})
        },
        selectLifeCategory(idx){
            var index = this.selectedLifeList.indexOf(idx); 
			if (index > -1) {
				this.selectedLifeList.splice(index, 1);
			} else {
                this.selectedLifeList.push(idx);
            }
        },
        getService(){
            var categories = "";
            for(var i = 0; i < this.selectedLifeList.length; i++){
                categories += this.selectedLifeList[i] + ","
            }

            if(categories === ""){
                categories = "0"
            }

            this.requestServiceBySubCategory({
                currentPage: this.currentPage,
                perPage: this.perPage,
                sortBy: this.sortBy,
                sortDesc: this.sortDesc,
                targetIdx : this.targetData.targetIdx,
                categories : categories
            })
            .then((result) => {
                if(result.status === 200){

                    this.items = result.data.items;
                    this.totalCnt = result.data.totalCnt;

                    if(this.items == null){
                        this.items = [];
                        this.totalCnt = 0;
                    }
                }
                else{
                    this.$alert('알림', '데이터를 가져올 수 없습니다.')      
                }
            })
            .catch(() => {
                this.$alert('알림', '통신을 실패했습니다.')  
            })
        },
        onClickPagenation (pageNum) {
            this.currentPage = pageNum;
            this.getProduct();
        }

    }
}
</script>